import { Component, OnInit } from '@angular/core';
import { MatriculacionService } from '../_services/matriculacion.service';
@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {
  cantidadErrores!:number;
  cantidadFinalizados!:number;
  cantidadEnProceso!:number;
  cantidadCertificados!:number;

  constructor(private matriculacionService:MatriculacionService) { }

  ngOnInit(): void {
    this.getSeguimiento();
    
  }

  getSeguimiento(){
    this.matriculacionService.getMetricas().subscribe(result=>{
      result.forEach((el:any) => {
        switch (el.descripcion){
          case "totalMatriculasCreadas":{
            this.cantidadCertificados=el.valor;
            break;
          }
          case "procesosIniciados":{
            this.cantidadEnProceso=el.valor;
            break;
          }
          case "procesosFinalizados":{
            this.cantidadFinalizados=el.valor;
            break;
          }
          case "procesosConError":{
            this.cantidadErrores=el.valor;
            break;
          }
        }
      });
    },(error)=>{
      this.cantidadCertificados=0;
      this.cantidadEnProceso=0;
      this.cantidadFinalizados=0;
      this.cantidadErrores=0;
    });
  }

}
